import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import { fireEvent } from '../utils/funnelEvents';
import ArticleStructuredData from '../components/ArticleStructuredData';
import RealtorsHeader from '../components/RealtorsHeader';

import RealtorsHero from './realtors/RealtorsHero';
import Workflow from './realtors/Workflow';
import PainPoints from './realtors/PainPoints';
import LocalFirst from './realtors/LocalFirst';
import RealtorsPricing from './realtors/Pricing';
import RealtorsFAQ from './realtors/RealtorsFAQ';
import ContactInfo from './realtors/ContactInfo';
import ResearchInviteCard from '../components/research/ResearchInviteCard';

const PAGE_TITLE =
  'AI File Organizer for Real Estate Agents | MLS Photos, ALTA & Transaction Docs | Sortio';
const PAGE_DESCRIPTION =
  'File organization for realtors. Sortio is an AI file organizer for real estate agents that sorts MLS listing photos, drone shots, ALTA settlement statements, and seller disclosures into per-property folders on your Mac or PC. Works with OneDrive, Dropbox, and Box. Preview every move before it happens; fully local AI optional.';

const RealtorsPage = () => {
  useEffect(() => {
    fireEvent('team_page_view', { vertical: 'realtors' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta
          name="keywords"
          content="file organization for realtors, MLS photo organizer, AI file organizer for real estate agents, organize listing photos by property, sort real estate transaction documents, transaction coordinator software file management, ALTA settlement statement organizer, drone photo organizer real estate, per-property file filing"
        />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.getsortio.com/for-realtors" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
        <link rel="canonical" href="https://www.getsortio.com/for-realtors" />
      </Helmet>
      <ArticleStructuredData
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        datePublished="2026-05-12T00:00:00.000Z"
        dateModified="2026-05-12T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <RealtorsHeader />
      <RealtorsHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <Workflow />
          <PainPoints />
          <LocalFirst />
          <RealtorsPricing />
          <RealtorsFAQ />
          <ResearchInviteCard vertical="real-estate" />
          <ContactInfo />
        </div>
      </div>
    </>
  );
};

export default RealtorsPage;
